document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('[data-role="booking-form"]') !== null) {
    document.querySelector('[data-role="booking-submit"]').addEventListener('click', () => {
      // Formより参照した値を利用
      const url = document.bookingForm.action;
      const prefVal = document.bookingForm.pf.value;
      const areaVal = document.bookingForm.ar.value;
      const numberOfPeopleVal = document.bookingForm.cp.value;
      const numberOfRoomVal = document.bookingForm.rn.value;
      const minBudgetVal = document.bookingForm.pn.value;
      const maxBudgetVal = document.bookingForm.px.value;
      const roomTypeVal = document.bookingForm.rt.value;
      const mealTypeVal = document.bookingForm.mc.value;
      const keywordsVal = document.getElementById('kw').value;

      // Formから参照した値を加工し利用
      const dateVal = document.bookingForm.sd.value.replace(/-/g, '');
      const kodawari01 = document.querySelectorAll('input[name="kd"]:checked');
      let kodawariVals = [];

      for (let i = 0; i < kodawari01.length; i++) {
        kodawariVals.push(kodawari01[i].value);
      }

      const kodawari02 = document.querySelectorAll('input[name="kw"]:checked');
      let kodawari02Vals = [];

      for (let i = 0; i < kodawari02.length; i++) {
        kodawari02Vals.push(kodawari02[i].value);
      }

      if (keywordsVal) {
        kodawari02Vals = ',' + kodawari02Vals;
      }

      const requestURL = `${url}?pf=${prefVal}&ar=${areaVal}&sd=${dateVal}&cp=${numberOfPeopleVal}&rn=${numberOfRoomVal}&pn=${minBudgetVal}&px=${maxBudgetVal}&rt=${roomTypeVal}&mc=${mealTypeVal}&kw=${keywordsVal}${kodawari02Vals}&${kodawariVals.join('&')}`;

      // debug
      //console.log(requestURL);

      window.open(requestURL, '_blank');
      return false;
    });
  }
});
